import React from 'react';
import { Link } from 'react-router-dom';
import { FiPhone, FiMail, FiMapPin } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-sharon-light-green py-8 border-t border-sharon-green">
      <div className="section-container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Contact Info */}
          <div className="text-center md:text-right">
            <h3 className="text-xl font-semibold text-sharon-dark-green mb-4">צרו קשר</h3>
            <ul className="space-y-2">
              <li className="flex items-center justify-center md:justify-end">
                <FiPhone className="ml-2 text-sharon-green" />
                <a href="tel:+972526507776" className="hover:text-sharon-dark-green transition-colors">
                  0526507776
                </a>
              </li>
              <li className="flex items-center justify-center md:justify-end">
                <FiMail className="ml-2 text-sharon-green" />
                <a href="mailto:sharon.weisfeld@gmail.com" className="hover:text-sharon-dark-green transition-colors">
                  sharon.weisfeld@gmail.com
                </a>
              </li>
              <li className="flex items-center justify-center md:justify-end">
                <FiMapPin className="ml-2 text-sharon-green" />
                <span>הוד השרון והסביבה</span>
              </li>
            </ul>
          </div>

          {/* Navigation */}
          <div className="text-center">
            <h3 className="text-xl font-semibold text-sharon-dark-green mb-4">ניווט</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-sharon-dark-green transition-colors">
                  דף הבית
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-sharon-dark-green transition-colors">
                  אודות
                </Link>
              </li>
              <li>
                <Link to="/family" className="hover:text-sharon-dark-green transition-colors">
                  טיפול משפחתי
                </Link>
              </li>
              <li>
                <Link to="/couple" className="hover:text-sharon-dark-green transition-colors">
                  טיפול זוגי
                </Link>
              </li>
              <li>
                <Link to="/personal" className="hover:text-sharon-dark-green transition-colors">
                  טיפול אישי
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-sharon-green text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} שרון וייספלד - פסיכולוגית. כל הזכויות שמורות.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;